import {appDebug} from '../../common/util';

const moduleDebug = appDebug.extend('this');


class RootScope {
    searchURLSep: string;
    searchInputSepRegEx: RegExp;
    searchEndGifs: string;
    searchEndMemes: string;
    searchEndStickers: string;
    searchEndRegEx: RegExp;
    tzOffset: number;

    constructor() {
        this.searchURLSep = '-';
        this.searchInputSepRegEx = /[\s,]+/g;
        this.searchEndGifs = `${this.searchURLSep}gifs`;
        this.searchEndMemes = `${this.searchURLSep}memes`;
        this.searchEndStickers = `${this.searchURLSep}stickers`;
        // eslint-disable-next-line max-len
        this.searchEndRegEx = new RegExp(`(${this.searchEndGifs}|${this.searchEndMemes}|${this.searchEndStickers})$`);
        this.tzOffset = new Date().getTimezoneOffset() * 60;
    }
    humanize(ts: number) {
        const seconds = (Date.now() / 1000) - ts;
        const minutes = seconds / 60;
        const hours = minutes / 60;
        const days = hours / 24;
        if (days > 1) {
            return `${Math.ceil(days)} d`;
        }
        if (hours > 1) {
            return `${Math.ceil(hours)} h`;
        }
        if (minutes > 1) {
            return `${Math.ceil(minutes)} m`;
        }
        return `${Math.ceil(seconds)} s`;
    }
}


// Prevent accidentally dropping files onto body, which would unload the
// page and load the dragged file.
function cancelEvent(e: DragEvent) {
    if (e) {
        e.stopPropagation();
        e.preventDefault();
    }
}

function onbodydragover(e: DragEvent) {
    cancelEvent(e);
    if (e?.dataTransfer) {
        e.dataTransfer.dropEffect = 'none';
    }
}
if (process.env.BROWSER) {
    document.body.ondrop = cancelEvent;
    document.body.ondragover = onbodydragover;
    document.body.ondragleave = cancelEvent;
    document.body.ondragend = cancelEvent;
}

export default new RootScope();
